/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Assest_PackInputs */

const en_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assest Pack`)
};

const es_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquete de recursos`)
};

const fr_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack de ressources`)
};

const de_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-Paket`)
};

const ja_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットパック`)
};

const zh_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素材包`)
};

const ar_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة أصول`)
};

const id_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Aset`)
};

const it_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetto di Risorse (Asset Pack)`)
};

const ru_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакет ресурсов`)
};

const pt_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote de Ativos`)
};

const ko_val_assest_pack = /** @type {(inputs: Val_Assest_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 팩`)
};

/**
* | output |
* | --- |
* | "Assest Pack" |
*
* @param {Val_Assest_PackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_assest_pack = /** @type {((inputs?: Val_Assest_PackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Assest_PackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_assest_pack(inputs)
	if (locale === "es") return es_val_assest_pack(inputs)
	if (locale === "fr") return fr_val_assest_pack(inputs)
	if (locale === "de") return de_val_assest_pack(inputs)
	if (locale === "ja") return ja_val_assest_pack(inputs)
	if (locale === "zh") return zh_val_assest_pack(inputs)
	if (locale === "ar") return ar_val_assest_pack(inputs)
	if (locale === "id") return id_val_assest_pack(inputs)
	if (locale === "it") return it_val_assest_pack(inputs)
	if (locale === "ru") return ru_val_assest_pack(inputs)
	if (locale === "pt") return pt_val_assest_pack(inputs)
	return ko_val_assest_pack(inputs)
});